import { inject, InjectionToken, Provider } from '@angular/core';

import {OrganizationDetailSignalStore} from '../../types';

import {ORGANIZATION_DETAIL_SIGNAL_STORE} from '../signal-store';

export const ORGANIZATION_DETAIL_TOKEN = new InjectionToken<OrganizationDetailSignalStore>('Organization Detail Signal Store');

export const ORGANIZATION_DETAIL_STORE_PROVIDER: Provider = {
  provide: ORGANIZATION_DETAIL_TOKEN,
  useClass: ORGANIZATION_DETAIL_SIGNAL_STORE
};

export function organizationDetailTokenizer() {
  return inject(ORGANIZATION_DETAIL_TOKEN);
}
